<script lang="ts" setup></script>

<template>
	<div class="bs-loader">
		<div class="bs-overlay">
			<span class="bs-loader__spinner"></span>
		</div>
	</div>
</template>
